import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Form, Input, Button, Spin, Icon } from 'antd';
import {
  RANG_MIN_MAX_CARACTERS_CONTRASENYA,
  MISSATGE_CAMP_OBLIGATORI,
  MISSATGE_CONTRASENYA_LONGITUD,
  MISSATGE_CONTRASENYA_NO_COINCIDEIXEN,
  MISSATGE_CANVI_CONTRASENYA_ERROR,
  MISSATGE_CANVI_CONTRASENYA_OK,
  MISSATGE_CANVI_CONTRASENYA_TITOL,
  MISSATGE_SPIN_CANVI_CONTRASENYA,
  MISSATGE_USUARI_NO_ACTIU,
} from '../constantsFormularis';
import styles from './CanviarContrasenyaFormulari.module.css';
import { NotificacioExit } from './Notification';
import { errorConsultaServidor } from '../actions';
import { rutaPerfil } from '../routes';
import { getUsuari } from '../reducers';
import {
  fetchCanviarContrasenya,
  fetchObtenirDadesUsuariPerIdObservador,
} from '../actions/consultesServidor';
import configuracio from '../configuracioEntorns';

class CanviarContrasenyaFormulari extends Component {
  state = {
    canviEnCurs: false,
    usuariNoActiu: false,
  };

  setCanviEnCurs = (value) => {
    this.setState({ canviEnCurs: value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;

    if (
      this.valorDintreRang(
        value,
        RANG_MIN_MAX_CARACTERS_CONTRASENYA[0],
        RANG_MIN_MAX_CARACTERS_CONTRASENYA[1]
      )
    ) {
      callback(MISSATGE_CONTRASENYA_LONGITUD);
    } else {
      if (value && value !== form.getFieldValue('contrasenyaNova')) {
        callback(MISSATGE_CONTRASENYA_NO_COINCIDEIXEN);
      } else {
        callback();
      }
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value) {
      form.validateFields(['contrasenyaNova2'], { force: true });
    }
    callback();
  };

  valorDintreRang = (valor, min, max) => {
    return valor && valor.length && (valor.length < min || valor.length > max);
  };

  gestioError = (error, tipusError) => {
    if (tipusError === MISSATGE_USUARI_NO_ACTIU) {
      this.setState({ usuariNoActiu: true });
    }
    this.props.errorConsultaServidor(error, tipusError);
  };

  handleCanvi = async (e) => {
    const dadesUsuari = await fetchObtenirDadesUsuariPerIdObservador(
      this.props.usuari.idObservador
    ).catch((error) => this.gestioError('Avís Error', error));

    if (dadesUsuari) {
      if (!dadesUsuari.actiu) {
        this.gestioError('Avís Error', MISSATGE_USUARI_NO_ACTIU);
      } else {
        this.setCanviEnCurs(true);
        e.preventDefault();
        const { form, usuari, history } = this.props;
        const idUsuari = usuari.id;

        form.validateFields((err, values) => {
          if (err) {
            this.setCanviEnCurs(false);
            return;
          }

          fetchCanviarContrasenya(
            idUsuari,
            values.contrasenyaActual,
            values.contrasenyaNova
          ).then(
            (dadesResultat) => {
              form.resetFields();
              this.setCanviEnCurs(false);
              dadesResultat && dadesResultat.message
                ? this.props.errorConsultaServidor(
                    dadesResultat.titol
                      ? dadesResultat.titol
                      : MISSATGE_CANVI_CONTRASENYA_TITOL,
                    dadesResultat.message
                  )
                : dadesResultat
                ? NotificacioExit(
                    MISSATGE_CANVI_CONTRASENYA_TITOL,
                    MISSATGE_CANVI_CONTRASENYA_OK
                  )
                : this.props.errorConsultaServidor(
                    MISSATGE_CANVI_CONTRASENYA_TITOL,
                    MISSATGE_CANVI_CONTRASENYA_ERROR
                  );
              history.push({
                pathname: rutaPerfil,
              });
            },
            (error) => {
              this.setCanviEnCurs(false);
              this.props.errorConsultaServidor(
                error,
                MISSATGE_CANVI_CONTRASENYA_TITOL
              );
            }
          );

          this.setCanviEnCurs(false);
        });
      }
    }
  };

  render() {
    const { usuariNoActiu } = this.state;

    if (usuariNoActiu) {
      const urlBase = configuracio.ruta;
      return <Redirect to={`${urlBase}/login`} />;
    }

    const { form, idUsuari } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Spin
        spinning={this.state.canviEnCurs}
        tip={MISSATGE_SPIN_CANVI_CONTRASENYA}
        delay={0}
      >
        <div>
          <h2 className={styles.title}>Canvi de contrasenya</h2>
          <div className={styles.login_form}>
            <Form layout="vertical" onSubmit={this.handleCanvi}>
              <Form.Item label="Contrasenya actual">
                {getFieldDecorator('contrasenyaActual', {
                  rules: [
                    {
                      required: true,
                      message: MISSATGE_CAMP_OBLIGATORI,
                    },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    type="password"
                    placeholder="Password"
                    autoComplete="current-password"
                  />
                )}
              </Form.Item>
              <Form.Item label="Nova contrasenya">
                {getFieldDecorator('contrasenyaNova', {
                  rules: [
                    {
                      required: true,
                      message: MISSATGE_CAMP_OBLIGATORI,
                    },
                    {
                      min: RANG_MIN_MAX_CARACTERS_CONTRASENYA[0],
                      max: RANG_MIN_MAX_CARACTERS_CONTRASENYA[1],
                      message: MISSATGE_CONTRASENYA_LONGITUD,
                    },
                    { validator: this.validateToNextPassword },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    type="password"
                    placeholder="Password"
                    autoComplete="new-password"
                  />
                )}
              </Form.Item>
              <Form.Item label="Repetir contrasenya">
                {getFieldDecorator('contrasenyaNova2', {
                  rules: [
                    {
                      required: true,
                      message: MISSATGE_CAMP_OBLIGATORI,
                    },
                    { validator: this.compareToFirstPassword },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    type="password"
                    placeholder="Password"
                    autoComplete="new-password"
                  />
                )}
              </Form.Item>
              <input
                type="hidden"
                id="idusuari"
                name="idusuari"
                value={idUsuari}
              />

              <Link
                className={styles.back}
                to={{
                  pathname: rutaPerfil,
                  query: { render: false },
                }}
              >
                <Button icon="left">Tornar</Button>
              </Link>

              <Button type="primary" htmlType="submit">
                Canviar
              </Button>

              <Form.Item />
            </Form>
          </div>
        </div>
      </Spin>
    );
  }
}

CanviarContrasenyaFormulari.propTypes = {
  errorConsultaServidor: PropTypes.func,
  history: PropTypes.object,
  usuari: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    usuari: getUsuari(state),
  };
};

const mapDispatchToProps = {
  errorConsultaServidor,
};

const WrappedNormalLoginForm = Form.create({ name: 'canvi_contrasenya' })(
  CanviarContrasenyaFormulari
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedNormalLoginForm);
